var current = 1;

function init(){
    var slideshow = document.querySelector("#propshow-slideshow-frame");
    
    var right = document.querySelector("#propshow-right");
    var left = document.querySelector("#propshow-left");
    
    right.addEventListener("click", e=>move(true));
    left.addEventListener("click", e=>move(false));
    
    function move(right){

        var images = slideshow.children;
        current = Math.floor(images.length/2);

        reshape(right);

        images[current + (right?-1:0)   ].classList.remove(`propshow-${right?"grow":"shrink"}-trans`);
        images[current + (right?-1:0)   ].classList.add(`propshow-${right?"shrink":"grow"}-trans`);

        
    }

    function reshape(right){
        var images = slideshow.childNodes;
        
        
        if (right){
            slideshow.appendChild(images[0]);
            images[images.length - 1].classList.remove(`propshow-shrink-trans`);
            images[images.length - 1].classList.add(`propshow-grow-trans`);
        }else{
            images[images.length - 1].classList.remove(`propshow-grow-trans`);
            images[images.length - 1].classList.add(`propshow-shrink-trans`);
            slideshow.insertBefore(images[images.length - 1], images[0]);
        }
    }

}
export default init;